import { useIsMobile } from '../../../../ds/hooks';
import { ActionError, StepFrame, useWizard } from '../StepFrame';
import { Panel } from '../parts';
import { PairingPanel, useWhatsappPairing } from '../WhatsAppPairing';
import styles from './WhatsAppStep.module.css';

/**
 * Nutzer 08 / M6: one panel at a time in the states of the frame (ready with countdown, expired with „Neu laden",
 * scan recognised with the three rows) — the frame's side-by-side view is a comparison of the states.
 */
export function WhatsAppStep() {
  const mobile = useIsMobile();
  const wizard = useWizard();
  const pairing = useWhatsappPairing(true);
  const connected = pairing.state === 'connected';
  const skip = {
    label: mobile ? 'Später' : 'Später verbinden',
    onClick: () => void wizard.act('skip'),
    loading: wizard.acting === 'skip',
  };
  return (
    <StepFrame
      title="WhatsApp mit Ihrem Diensthandy verbinden"
      text="Nachrichten laufen über Ihr Diensthandy. Sie scannen den Code einmal in WhatsApp, die Session bleibt offen, bis Sie sie beenden."
      mobileTitle="WhatsApp verbinden"
      mobileText="Auf dem Diensthandy WhatsApp öffnen und unter Verknüpfte Geräte den Code scannen. Die Session bleibt offen, bis Sie sie beenden."
      width={mobile ? 390 : 760}
      footer={{
        back: wizard.goBack ? { label: 'Zurück', onClick: wizard.goBack } : undefined,
        secondary: skip,
        primary: {
          label: 'Weiter',
          onClick: () => void wizard.act('continue'),
          loading: wizard.acting === 'continue',
          disabled: !connected,
        },
      }}
      mobileFooter={{
        secondary: skip,
        primary: connected
          ? {
              label: 'Weiter',
              onClick: () => void wizard.act('continue'),
              loading: wizard.acting === 'continue',
            }
          : {
              label: 'Neuen Code laden',
              onClick: pairing.refresh,
              loading: pairing.busy,
              disabled: !pairing.status,
            },
      }}
    >
      <Panel
        className={mobile ? styles.mobilePanel : styles.panel}
        tone={pairing.state === 'qr' ? 'accent' : undefined}
      >
        <PairingPanel pairing={pairing} size={mobile ? 196 : 204} variant={mobile ? 'mobile' : 'wizard'} />
      </Panel>
      {mobile ? null : (
        <p className={styles.note}>
          Kein Diensthandy zur Hand? Überspringen Sie den Schritt, er landet in der Checkliste.
        </p>
      )}
      <ActionError />
    </StepFrame>
  );
}
